import React from 'react';
import { Box } from '@mui/material';

/**
 * The floating HTML tooltip. Positioned by placeTooltip at hover time, so it is
 * `position: fixed` and starts hidden. Pointer-events off — it must never
 * intercept the hover that is keeping it open.
 */
export const TooltipBox = React.forwardRef<
    HTMLDivElement,
    { minWidth: number; maxWidth: number }
>(({ minWidth, maxWidth }, ref) => (
    <Box
        ref={ref}
        sx={{
            position: 'fixed',
            display: 'none',
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            borderRadius: '4px',
            px: 1.25,
            py: 0.75,
            pointerEvents: 'none',
            zIndex: 1400,
            boxShadow: 1,
            minWidth,
            maxWidth,
            boxSizing: 'border-box',
            fontSize: '11px',
            lineHeight: 1.4,
            color: 'text.primary',
            overflow: 'hidden',
            '& *': { minWidth: 0 },
            '& div, & span': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        }}
    />
));
TooltipBox.displayName = 'TooltipBox';
